import { render, staticRenderFns } from "./SimularApplications.vue?vue&type=template&id=2ff169d3&lang=pug"
import script from "./SimularApplications.vue?vue&type=script&lang=js"
export * from "./SimularApplications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports